import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "@/locales/en.json";
import es from "@/locales/es.json";
import de from "@/locales/de.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
      de: { translation: de },
    },
    fallbackLng: "en",
    supportedLngs: ["en", "es", "de"],
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "aieco.lang",
      caches: ["localStorage"],
    },
    interpolation: { escapeValue: false },
  });

export const LANGUAGES = [
  { code: "en", label: "English", flag: "EN" },
  { code: "es", label: "Español", flag: "ES" },
  { code: "de", label: "Deutsch", flag: "DE" },
];

export default i18n;
